module.exports = __webpack_public_path__ + "static/img/ic_launcher_round_sbpz.301e320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_launcher_round_sbpz.png
// module id = H6+K
// module chunks = 4